<script lang="ts"></script>

<style lang="scss">
  :host {
    display: flex;
  }
</style>
